<template>
    <div class="about">
        <header-nav></header-nav>
        <div class="mob-content">
            <div class="mob-about-content">
                <span class="mob-about-content-title">产品介绍</span>
                <p class="mob-about-content-p">雷电云手机是一款优秀的手机应用云平台，全面支持各种手机应用程序的展示、下载及应用与管理服务。并卓越实现全天候云端智能托管应用，让用户在脱离移动终端的状态下，也能将各种应用程序托管到云端，保持全天候在线。</p>
            </div>
            <div class="mob-about-content">
                <span class="mob-about-content-title">公司背景</span>
                <p class="mob-about-content-p">广州易指网络科技有限公司，成立于2019年，是中国领先的云游戏研发企业。
                    公司一直秉承“用户至上，追求卓越”的经营理念，以“打造全球优秀的云游戏产品”为经营目标，凭借着对虚拟化技术、安卓操作系统、Linux内核等核心技术的深刻理解，凭借着对游戏行业现状和发展趋势的深刻认识，务实进取，不断创新，开创并且引领公司前行发展。 
                    公司汇集了一批来自腾讯、网易、阿里巴巴、欢聚时代等国内顶尖互联网企业的精英人士。
                    旗下主要产品雷电云手机，是一款性能强大、运行稳定的云端虚拟手机产品。
                    雷电云手机，您的24小时云端托管神器！
                </p>
            </div>
            <div class="mob-about-content">
                <span class="mob-about-content-title">联系方式</span>
                <div class="mob-about-content-list">
                    <div v-for="(item,idx) in contactWayList"
                         :key="idx">
                        <img :src="item.icon"
                             alt="">
                        <div class="list-content">
                            <span>{{item.title}}</span>
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HeaderNav from '@/views/mobile/components/head-nav.vue'

export default {
	name: 'About',
	data() {
		return {
			contactWayList:[
				{
                    icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-site.png',
                    title: '地址',
					content: '广州市天河区中山大道西1132号汇鑫商业大厦413室'
				},
				// {
                //     icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-email.png',
                //     title: '商务合作邮箱',
				// 	content: 'czsw@ldmnq.com'
				// },
				{
                    icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-qq.png',
                    title: '客服QQ',
					content: '1081322573（群）'
				},
				{
                    icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-business.png',
                    title: '商务QQ',
					content: '2460396546'
				}
			]
		}
	},
	components: {
		HeaderNav
	}
}
</script>
<style lang="scss" scoped>
.mob-content {
    margin-top: 128px;
    padding: 80px 45px 50px;
}
.mob-about-content {
    margin-top: 80px;
    .mob-about-content-title {
        font-weight: bold;
        font-size: 30px;
        color: #000000;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0px;
            display: block;
            width: 93px;
            height: 10px;
            background: #ffcc00;
            border-radius: 4px;
            z-index: -1;
        }
    }
    .mob-about-content-p {
        margin-top: 20px;
        font-size: 24px;
        line-height: 40px;
        color: #333;
        opacity: 0.9;
        text-align: justify;
    }
    .mob-about-content-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 80px;
        > div {
            margin-top: 26px;
            padding: 0 50px;
            width: 480px;
            height: 190px;
            border: 1px solid #d7d7d7;
            border-radius: 16px;
            display: flex;
            // flex-direction: column;
            align-items: center;
            // justify-content: space-between;
            // .list-content {
            //     // display: flex;
            // }
            img:nth-child(1) {
                width: 87px;
                height: 86px;
            }
            img:nth-child(3) {
                width: 84px;
                height: 61px;
            }
            img:nth-child(5) {
                width: 70px;
                height: 80px;
            }
            img:nth-child(7) {
                width: 78px;
                height: 60px;
            }
        }
        .list-content {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            span {
                color: #333333;
                font-size: 14px;
            }
            p {
                // line-height: 30px;
                margin-top: 20px;
                color: #333333;
                font-size: 14px;
                text-align: justify;
            }
        }
    }
}
.mob-about-content:first-child {
    margin-top: 0;
}
</style>
